import React from 'react';
import Centerer from '../../containers/centerer';

export default function CentererDefinition(content) {
	if (!(this instanceof CentererDefinition)) {
		return new CentererDefinition(content);
	}

	let width;
	let maxWidth;
	let visibleCallback;
	let visible = true;

	if (typeof content === 'function') {
		content._parentDefinition = this;
	}

	this.setWidth = function(value) {
		width = value;
		return this;
	};

	this.setMaxWidth = function(value) {
		maxWidth = value;
		return this;
	};

	this.getContent = function() {
		return content;
	};

	this.validateAll = function(ctx, errors) {
		content.validateAll(ctx, errors);
	};

	this.setVisible = function(value) {
		if (typeof value === 'function') {
			visibleCallback = value;
			visible = true;
		} else {
			visibleCallback = null;
			visible = value;
		}
		return this;
	};

	const isVisible = function(ctx) {
		if (visibleCallback) {
			return visibleCallback(ctx);
		} else {
			return visible;
		}
	};


	this.render = function(ctx, key = 0) {
		if (!isVisible(ctx)) {
			return null;
		}
		return (
			<Centerer key={key} width={width} maxWidth={maxWidth}>
				{content.render(ctx)}
			</Centerer>
		)
	};
}

